import {
  ApprovalsFlowFragment,
  UpdateApprovalFlowMutationVariables,
} from 'generated/resources/graphql'

export type ApprovalFlowArgs = Omit<UpdateApprovalFlowMutationVariables, 'onApprovalFlowChange'> & {
  id: number | null
  approvalGroupId: number | null
}

export type ApproverArgs = ApprovalFlowArgs['steps'][number]['approvers'][number]

export const defaultApprover: ApproverArgs = {
  id: null,
  strategy: 'manager',
  accessId: null,
}

export const defaultApprovalFlow: ApprovalFlowArgs = {
  id: null,
  approvalGroupId: null,
  name: '',
  default: false,
  steps: [{ id: null, position: 0, approvers: [defaultApprover] }],
  stepIdsToBeDeleted: [],
}

export const approvalFlowToArgs = (
  approvalFlow: ApprovalsFlowFragment | undefined | null
): ApprovalFlowArgs => {
  if (!approvalFlow) {
    return defaultApprovalFlow
  }

  return {
    id: approvalFlow.id,
    approvalGroupId: approvalFlow.approvalGroupId,
    name: approvalFlow.name,
    default: approvalFlow.default,
    stepIdsToBeDeleted: [],
    steps: approvalFlow.steps.map((step) => {
      return {
        id: step.id,
        position: step.position ?? 0,
        approvers: step.approvers.map((approver) => {
          return {
            id: approver.id,
            strategy: approver.strategy,
            accessId: approver.accessIds?.[0] || null,
            groupableId: approver.groupableId,
            groupableType: approver.groupableType,
          }
        }),
      }
    }),
  }
}
